export const tabItems = {
  payslips: 'payslips',
  compensation: 'compensation',
  form16: 'form16',
};

export const compensationTabItems = {
  ctc: 'ctc',
  bonus: 'bonus',
  deductions: 'deductions',
  perquisites: 'perquisites',
  flexi: 'flexi',
};

export const queryKeys = {
  FETCH_USER_DETAILS: 'FETCH_USER_DETAILS',
  FETCH_COMPENSATION_DETAILS: 'FETCH_COMPENSATION_DETAILS',
  FETCH_LIST_DEDUCTIONS: 'FETCH_LIST_DEDUCTIONS',
  FETCH_VPF_DETAILS: 'FETCH_VPF_DETAILS',
  FETCH_EMPLOYEE_TAX_REGIME: 'FETCH_EMPLOYEE_TAX_REGIME',
};

export const DEDUCTION_TYPE_RECURRING = 'RECURRING';

export const statutoryComponentNameMap = {
  pf: 'Employer PF Contribution',
  esi: 'Employer ESI Contribution',
  vpf: 'Employer VPF Contribution',
  lwf: 'Employer LWF Contribution',
};

export const links = {
  learnMoreAboutVpf: 'https://razorpay.com/docs/payroll/voluntary-provident-fund/',

};

export const EMPLOYER_NPS_COMPONENT_NAME = 'Employer NPS';

export const BONUS_HELP_ARTICLE_URL =
  'https://intercom.help/XPayroll/en/articles/8320127-how-do-i-create-an-employee-bonus';